import { Component } from "react";
import dayjs from "dayjs";
import mediumZoom from 'medium-zoom';
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';

class MessageA20 extends Component {
  componentDidMount() {
    // Apply zoom to image if "clickableA20" flag is enabled
    // TODO: remove configDetails?.clickableA20
    if (!!this.props.config.designDetails?.clickableA20 || !!this.props.config.configDetails?.clickableA20)
      this.zoom = mediumZoom('.a20-image', { background: '#121212' });
  }

  componentWillUnmount() {
    // Detach zoom on unmount to avoid memory leaks
    if (this.zoom) {
      this.zoom.detach();
    }
  }

  render() {
    // console.log("MessageA20", this.props.entry);
    let imageURL = this.props?.entry?.text_data?.link
      ? this?.props?.entry?.text_data?.link
      : this?.props?.entry?.url;
    let captionText = this?.props?.entry?.text_data?.caption;

    return (
      <div
        className={this.messageContainerClassName()}
        style={this.messageContainerStyle()}
      >
        <div
          className={this.messageBoxClassName()}
          style={this.messageBoxStyle()}
          onClick={this.showImageInNewTab}
        >
         {(imageURL.endsWith('.pdf')) 
            ?
              <div onClick={()=>window.open(imageURL)} role="button" tabIndex={0} aria-label="Open PDF attachment" onKeyDown={(e)=>{ if(e.key==="Enter"||e.key===" "){ e.preventDefault(); window.open(imageURL); } }}>
                <PictureAsPdfIcon sx={{ fontSize: 28 }}/>
              </div>
            :
              <img className="a20-image" style={{ width: "100%" }} src={imageURL} alt={captionText || "Attached image"} />
          }
          <p style={{paddingTop: 10}}>{captionText}</p>
        </div>

        {this.props.isLastEntry && this.props.sentTimestamp && (
          <div
            className={this.messageTimeClassName()}
            style={this.messageTimeStyle()}
          >
            {dayjs
              .unix(Math.trunc(this.props.sentTimestamp / 1000))
              .format("DD MMM h:mm a")}
          </div>
        )}
      </div>
    );
  }

  showImageInNewTab = () => {
    let imageLink = this.props.message.message.text;
    if (!imageLink) {
      return;
    }
    window.open(imageLink, "_blank");
  };

  messageTimeClassName = () => {
    return "s360-message-time-received";
    // switch (this.props.message.type) {
    //     case MessageType.sent: return "s360-message-time-sent";
    //     case MessageType.received: return "s360-message-time-received";
    //     case MessageType.info: return "s360-message-time-info";
    //     default: return "";
    // }
  };

  messageBoxClassName = () => {
    return this.props?.entry?.text_data?.link
      ? "s360-message-box-img-received"
      : "s360-message-box-custom-received";
    // switch (this.props.message.type) {
    //     case MessageType.sent: return "s360-message-box-sent";
    //     case MessageType.received: return "s360-message-box-received";
    //     case MessageType.info: return "s360-message-box-info";
    //     default: return "";
    // }
  };

  messageContainerClassName = () => {
    return this.props.config.autoFullScreen
      ? "s360-message-cotainer-received-fs"
      : "s360-message-cotainer-received";
    // switch (this.props.message.type) {
    //     case MessageType.sent: return "s360-message-cotainer-sent";
    //     case MessageType.received: return "s360-message-cotainer-received";
    //     case MessageType.info: return "s360-message-cotainer-info";
    //     default: return "";
    // }
  };

  messageBoxStyle = () => {
    let config = this.props.config;
    return {
      background: config.designDetails.senderMessageColor,
      fontFamily: config.designDetails.SenderMessageFont,
      fontSize: config.designDetails.SenderMessageFontSize,
      color: config.designDetails.senderMessageFontColor,
    };
    // switch (this.props.message.type) {
    //     case MessageType.received: return { height: "105px", background: config.designDetails.senderMessageColor, fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageFontSize, color: config.designDetails.senderMessageFontColor }
    //     case MessageType.sent: return { height: "105px", background: config.designDetails.recieverMessageColor, fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageFontSize, color: config.designDetails.recieverMessageFontColor }
    //     default: return {}
    // }
  };

  messageContainerStyle = () => {
    // let config = this.props.config
    return {};
  };

  messageTimeStyle = () => {
    let config = this.props.config;
    return {
      fontFamily: config.designDetails.messageFont,
      fontSize: config.designDetails.messageTimeFontSize,
      color: config.designDetails.messageTimeFontColor,
    };
    // let fontSize = config.designDetails.messageFontSize - (config.designDetails.messageFontSize / 4);
    // switch (this.props.message.type) {
    //     case MessageType.received: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageFontColor }
    //     case MessageType.sent: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageFontColor }
    //     case MessageType.info: return { fontFamily: config.designDetails.messageFont, fontSize: config.designDetails.messageTimeFontSize, color: config.designDetails.messageFontColor }
    //     default: return {}
    // }
  };
}

export default MessageA20;
